/** Redux Packages. */
import { configureStore } from '@reduxjs/toolkit';

import snackBarSlice from './snackBarSlice';
import addOnsSlice from './addOnsSlice';
import tradePartnersSlice from './tradePartnersSlice';

export const store = configureStore({
    reducer: {
        snackBar: snackBarSlice,
        addOns: addOnsSlice,
        tradePartners: tradePartnersSlice,
    },
});
